(function () {
  if (!document.body.classList.contains('page-a-propos')) return;

  var legacyMarkers = [
    'Nos marques partenaires',
    'Visitez nos boutiques',
    'espace-apropos-brands',
    'espace-apropos-cta',
  ];

  function shouldRemoveSection(section) {
    if (section.querySelector('.espace-apropos-page')) return false;
    var html = section.innerHTML || '';
    var text = (section.textContent || '').replace(/\s+/g, ' ');
    for (var i = 0; i < legacyMarkers.length; i++) {
      if (html.indexOf(legacyMarkers[i]) !== -1 || text.indexOf(legacyMarkers[i]) !== -1) {
        return true;
      }
    }
    return false;
  }

  document.querySelectorAll('.shopify-section').forEach(function (section) {
    if (shouldRemoveSection(section)) section.remove();
  });

  document.querySelectorAll('.espace-apropos-brands, .espace-apropos-cta').forEach(function (el) {
    if (!el.closest('.espace-apropos-page')) el.remove();
  });
})();
